import { authService } from '../../../users/services';
import { BasicGroupService } from './basicGroupService';
import { GroupService } from './groupsService';

const groupService = new GroupService(authService);
const basicGroupService = new BasicGroupService(authService);

export { groupService, basicGroupService };
